import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BlogRoutingModule } from './blog-routing.module';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    BlogRoutingModule
  ]
})
export class BlogModule { }
